var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.height},[_c('battery-level',{attrs:{"data":_vm.errorPowerList}}),_c('battery-low-level',{attrs:{"data":_vm.seatPowerList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }